export const GLOBAL_FLUTTER_CHANNELS = {
  DEBUG: 'debug',
  LOG: 'log',
  POKER_APP_EVENT: 'poker_app_event',
};

export const REGISTER_EVENTS = {
  FORM_READY: 'register_ready',
  FORM_UPLOAD_DOCUMENT: 'register_upload_document',

  FORM_SUBMIT: 'register_submit',
  AUTO_LOGIN: 'register_login',
  FORM_CLOSE: 'register_close',
  SERVER_OR_NETWORK_ERROR: 'register_global_error',
};

export const GLOBAL_EVENTS = {
  CHANGE_LANGUAGE: 'change_language',
  CHANGE_CURRENCY: 'change_currency',
  FORM_FYU: 'register_fyu',
  FORM_FYP: 'register_fyp',
};

export type FlutterDataPayload = {
  event: string;
  [key: string | number]: any;
};